export default __webpack_public_path__ + "static/D-DINExp-Italic-8d140efce6236fbc221642bff2dbd9ab.woff";